module.exports = __webpack_public_path__ + "media/images/épilation-9c9d213cbe99e7960c4949e8aa2c3a5a.svg";